import Page from "components/Page";
import React, { useEffect, useState } from "react";
import Table from "components/table";
import { withTranslation } from "react-i18next";
import InfoModal from "components/CustomModal/InfoModal";
import styles from "./StaffListingLeaves.module.scss";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { decodeId, formatLocalDateTime } from "utils";
import { useLeaveHistoryLogs } from "repositories/leave-repository";
import Loader from "components/Loader";

const LeavesHistoryLogs = ({ t }) => {
  const [deleteReason, setDeleteReason] = useState("");
  const [isDeleteReasonModalOpen, setIsDeleteReasonModalOpen] = useState(false);
  const history = useHistory();
  let { leaveId } = useParams();
  leaveId = decodeId(leaveId);
  const { data: leavehistoryDetail, isLoading } = useLeaveHistoryLogs(leaveId);

  const leaveStatusMap = {
    1: { label: "Applied", style: styles["applied"] },
    2: { label: "Approved", style: styles["approved"] },
    3: { label: "Rejected", style: styles["rejected"] },
    4: {
      label: "Cancellation Requested",
      style: styles["cancellationPending"],
    },
    5: {
      label: "Cancellation Request Accepted",
      style: styles["cancellationAccepted"],
    },
    6: {
      label: "Cancellation Request Rejected",
      style: styles["cancellationRejected"],
    },
    7: { label: "Withdrawn", style: styles["withdrawn"] },
    8: { label: "Archieved", style: styles["archieved"] },
    9: { label: "Unarchieved", style: styles["unarchieved"] },
    10: { label: "Edited ", style: styles["edited"] },
  };

  const handleStaffLeaveListStatus = (statusId) => {
    const status = leaveStatusMap[statusId];
    return status ? (
      <p className={status.style + " m-0"}>{t(status.label)}</p>
    ) : null;
  };

  const columns = [
    {
      attrs: {
        datatitle: "Action",
      },
      dataField: "actions",
      text: "Action",
      formatter: (cellContent, row) => (
        <div className={styles.btn_background}>
          {handleStaffLeaveListStatus(row?.actionType)}
        </div>
      ),
    },
    {
      attrs: {
        datatitle: "Action Taken On",
      },
      dataField: "actionTakenOn",
      text: "Action Taken On",
      formatter: (cellContent, row) => (
        <p className="m-0">
          {formatLocalDateTime(row?.actionPerformedOn, "ll")}
        </p>
      ),
    },
    {
      attrs: {
        datatitle: "Performed by",
      },
      dataField: "performedBy",
      text: "Performed by",
      formatter: (cellContent, row) => (
        <span> {row?.actionPerformedBy?.firstName} </span>
      ),
    },
    {
      attrs: {
        datatitle: "Reason",
      },
      dataField: "reason",
      text: "Reason",
      formatter: (cellContent, row) =>
        row?.reason ? (
          <span
            className="text-blue-500 cursor-pointer link-btn"
            onClick={() => {
              setDeleteReason(row.reason);
              setIsDeleteReasonModalOpen(true);
            }}
          >
            View Reason
          </span>
        ) : (
          <span>--</span>
        ),
    },
  ];

  const goBack = () => {
    history.goBack();
  };

  return (
    <Page
      title={t("scheduler.historyLogs", {
        eventOrShiftOrLeave: t("staff.leaves"),
      })}
      onBack={() => {
        goBack();
      }}
    >
      {isLoading && <Loader />}
      <div className="table-td-last-50 td-first-col-color common-fw-400 sales-representative-table shadow-responsive margin30">
        <Table
          keyField="id"
          data={leavehistoryDetail?.data?.leave || []}
          columns={columns}
        />
      </div>
      {isDeleteReasonModalOpen && (
        <InfoModal
          isOpen={isDeleteReasonModalOpen}
          setIsOpen={() => setIsDeleteReasonModalOpen(false)}
          title={t("staff.reason")}
          subTitle={deleteReason}
          addSpacingInHeading=" text-break text-wrap mb-4"
          btnText={t("close")}
          isContentCenter={false}
          modalStyle={{
            ContentSize: "14px",
            weight: "600",
            color: " #102C42",
            textTransform: "unset",
          }}
        />
      )}
    </Page>
  );
};
export default withTranslation()(LeavesHistoryLogs);
